import { Box, Stack } from '@mui/material'
import type { ReactNode } from 'react'

/** Section label with the thin gold rule beneath it. */
export default function SectionHead(
  { label, right }: { label: string; right?: ReactNode },
) {
  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={1}
        sx={{ px: 2, pt: 1.75, pb: 1 }}>
        <span className="section-label">{label}</span>
        <Box sx={{ flex: 1 }} />
        {right}
      </Stack>
      <Box className="rule-gold" sx={{ mx: 2, mb: 0.5 }} />
    </Box>
  )
}
